var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_550_4912)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86812 10.4727C2.24365 13.734 4.69906 16.3935 7.93275 17.2017C6.55009 15.2056 5.71039 12.8957 5.50246 10.4727H1.86812ZM1.86812 8.72727H5.50008C5.70391 6.31576 6.54464 4.00095 7.93246 1.9984C4.69892 2.80667 2.24364 5.4661 1.86812 8.72727ZM18.1319 8.72727C17.7563 5.466 15.3009 2.80651 12.0672 1.99832C13.4499 3.99443 14.2896 6.30425 14.4975 8.72727H18.1319ZM18.1319 10.4727H14.4999C14.2961 12.8842 13.4554 15.199 12.0675 17.2016C15.3011 16.3933 17.7564 13.7339 18.1319 10.4727ZM7.32252 8.72727H12.6749C12.4466 6.3594 11.5179 4.10349 9.99998 2.22613C8.47636 4.11023 7.54642 6.37322 7.32252 8.72727ZM12.6775 10.4727H7.32508C7.55344 12.8406 8.48212 15.0965 10 16.9739C11.5236 15.0898 12.4536 12.8268 12.6775 10.4727ZM10 19.2C4.47715 19.2 0 14.9019 0 9.6C0 4.29807 4.47715 0 10 0C15.5228 0 20 4.29807 20 9.6C20 14.9019 15.5228 19.2 10 19.2Z",
    fill: "#C1C7D0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_550_4912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86812 10.4727C2.24365 13.734 4.69906 16.3935 7.93275 17.2017C6.55009 15.2056 5.71039 12.8957 5.50246 10.4727H1.86812ZM1.86812 8.72727H5.50008C5.70391 6.31576 6.54464 4.00095 7.93246 1.9984C4.69892 2.80667 2.24364 5.4661 1.86812 8.72727ZM18.1319 8.72727C17.7563 5.466 15.3009 2.80651 12.0672 1.99832C13.4499 3.99443 14.2896 6.30425 14.4975 8.72727H18.1319ZM18.1319 10.4727H14.4999C14.2961 12.8842 13.4554 15.199 12.0675 17.2016C15.3011 16.3933 17.7564 13.7339 18.1319 10.4727ZM7.32252 8.72727H12.6749C12.4466 6.3594 11.5179 4.10349 9.99998 2.22613C8.47636 4.11023 7.54642 6.37322 7.32252 8.72727ZM12.6775 10.4727H7.32508C7.55344 12.8406 8.48212 15.0965 10 16.9739C11.5236 15.0898 12.4536 12.8268 12.6775 10.4727ZM10 19.2C4.47715 19.2 0 14.9019 0 9.6C0 4.29807 4.47715 0 10 0C15.5228 0 20 4.29807 20 9.6C20 14.9019 15.5228 19.2 10 19.2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_550_4912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0174 -0.799988H-0.800781V20.3862H21.0174V-0.799988Z",
    fill: "#6C798F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_550_4912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.d7fa91ad483a2d66664daa230d89aefb.svg";
export { ForwardRef as ReactComponent };